var _rect, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_284",
    "data-name": "Group 284",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.981,
    height: 29.51,
    viewBox: "0 0 14.981 29.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(2.483 22.719)",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 9.983,
    height: 5.98,
    transform: "translate(0 0.02) rotate(-0.113)",
    fill: "#bfc6d8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(2.5 24.142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 9.995,
    height: 1.454,
    transform: "translate(0 0.02) rotate(-0.113)",
    fill: "#abb3c4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(0.772 28.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262-2",
    "data-name": "Group 262-2",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M203.521,545.217l11.791-.023a.68.68,0,0,1,.682.679h0l-13.152.026a.68.68,0,0,1,.679-.682Z",
    transform: "translate(-202.842 -545.194)",
    fill: "#b2bacc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_263-2",
    "data-name": "Group 263-2",
    transform: "translate(0 0.672)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 13.159,
    height: 0.148,
    transform: "translate(0 0.026) rotate(-0.113)",
    fill: "#a2aaba"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217-2",
    "data-name": "Rectangle 217-2",
    width: 14.933,
    height: 24.132,
    rx: 0.652,
    transform: "translate(0 0.03) rotate(-0.113)",
    fill: "#bfc6d8",
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_218-2",
    "data-name": "Rectangle 218-2",
    d: "M203.068,517.284l12.773-.025a.326.326,0,0,1,.321.331h0l.043,21.917a.326.326,0,0,1-.318.334h0l-12.773.025a.327.327,0,0,1-.321-.331v0l-.043-21.917a.326.326,0,0,1,.319-.333Z",
    transform: "translate(-202.067 -516.531)",
    fill: "#a2aaba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    d: "M203.818,518.038l11.313-.022a.168.168,0,0,1,.168.168h0l.041,20.734a.169.169,0,0,1-.168.169l-11.312.022a.17.17,0,0,1-.17-.169h0l-.041-20.731a.171.171,0,0,1,.169-.17Z",
    transform: "translate(-202.067 -516.531)",
    fill: "#ebedf2",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgIn);
export default __webpack_public_path__ + "static/media/dg-in.fc617bbdf8ba3866e2141ccc6e5d64e3.svg";
export { ForwardRef as ReactComponent };